module.exports = __webpack_public_path__ + "img/3@2x.98d7870.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/3@2x.png
// module id = uthP
// module chunks = 0